module.exports = __webpack_public_path__ + "img/logos24.88abe284.jpg";